"use client"

import { useState } from "react"
import { MediaItem } from "../../../components/MediaItem"
import { MediaBlock } from "./MediaBlock"
import { Wysiwyg } from "@/components"
import { ChevronLeftIcon, ChevronRightIcon } from "@/icons/outline"
import { IconButton } from "@/elements"

export interface MediaCarouselBlockProps {
  id: string
  carousel_items: {
    media_id: MediaBlock & {
      media_text_content?: string
    }
  }[]
}

export const MediaCarouselBlock = (props: MediaCarouselBlockProps) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const handlePrevious = () => {
    setCurrentIndex(current => (current === 0 ? props.carousel_items.length - 1 : current - 1))
  }

  const handleNext = () => {
    setCurrentIndex(current => (current === props.carousel_items.length - 1 ? 0 : current + 1))
  }

  return (
    <div className="group relative w-full overflow-hidden">
      <div
        className="flex w-full transition-transform duration-300 ease-in-out"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
        {props.carousel_items.map(item => (
          <div className="w-full shrink-0" key={item.media_id.id}>
            <MediaItem {...item.media_id} />
            {item.media_id?.media_text_content ? <Wysiwyg block_wysiwyg={item.media_id.media_text_content} /> : null}
          </div>
        ))}
      </div>

      {/* Navigation Buttons */}
      <div className="absolute left-4 top-1/2 flex -translate-y-1/2 transform opacity-0 transition-all group-hover:opacity-100">
        <IconButton Icon={ChevronLeftIcon} variant="blur" onClick={handlePrevious} />
      </div>
      <div className="absolute right-4 top-1/2 flex -translate-y-1/2 transform opacity-0 transition-all group-hover:opacity-100">
        <IconButton Icon={ChevronRightIcon} variant="blur" onClick={handleNext} />
      </div>

      {/* Dots */}
      <div className="absolute bottom-4 left-1/2 flex -translate-x-1/2 gap-2">
        {props.carousel_items.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`h-2 w-2 rounded-full transition-all ${index === currentIndex ? "bg-white w-4" : "bg-white/50"}`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  )
}
